import { ChildModel, ModelBase } from 'store/model-base';
import { StreetAddress } from 'store/user/models';

export class ActivationPortInfo extends ModelBase {
    public firstName: string;
    public lastName: string;
    public accountNumber: string;
    public accountPin: string;
    public carrierName: string;
    public accountBillingAddress: StreetAddress;
    public ssn: string;

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'accountBillingAddress',
            model: StreetAddress
        }];
    }
}
